import { render, staticRenderFns } from "./Blockquote.vue?vue&type=template&id=303e9364&"
import script from "./Blockquote.vue?vue&type=script&lang=js&"
export * from "./Blockquote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports